export default __webpack_public_path__ + "static/media/FRZK1udVIAAI4ug.6c772888.jpg";